import React from 'react'

import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  ColumnContent,
  Label,
  Select,
  SelectOption,
  Stack,
  Term,
  Text,
} from '@enechain/ecloud-designsystem'
import { useErrorToast } from '@enechain/eposition-ui'

import { AVAILABLE_DEAL_SIMULATION_MAX_SIZE } from '~/pages/Simulation/models/AvailableDealSimulationRelationModel'
import { OrderSimulationSchema } from '~/pages/Simulation/schemas'

function createOptions(prefix: string, length: number): SelectOption[] {
  return Array.from({ length }, (_, i) => ({
    label: `${prefix}${i + 1}`,
    value: (i + 1).toString(),
  }))
}

export const AvailableDealSimulationRelationForm: React.FC = () => {
  const { t } = useTranslation(['page', 'common'])
  const { control, setValue } = useFormContext<OrderSimulationSchema>()
  const orderPatterns = useWatch({
    control,
    name: 'orderPattern',
  })
  const watchedRelations = useWatch({
    control,
    name: 'availableDealSimulationRelation',
  })
  const { showToast: showErrorToast } = useErrorToast({
    toastId: 'AvailableDealSimulationRelationForm/error',
  })

  const options = createOptions(
    t('page:simulation.input_order'),
    orderPatterns?.length ?? 0,
  )

  return (
    <Stack
      gap="4"
      paddingX="6"
      paddingY="4"
      border="1px solid"
      borderColor="Border.midEmphasis"
      borderRadius="radiiLg"
    >
      <Term>
        <Label required>{t('page:simulation.order_selection')}</Label>
        <Select<SelectOption, true>
          isMulti
          placeholder={t('common:action.neutral.of_select', {
            value: t('page:simulation.input_order'),
          })}
          onChange={(item): void => {
            if (item.length > 3) {
              showErrorToast({
                toastMessage: t(
                  'page:simulation.error_message.exceed_max_available_deal_simulation_pattern',
                  { value: AVAILABLE_DEAL_SIMULATION_MAX_SIZE + 1 },
                ),
              })
              return
            }
            setValue(
              'availableDealSimulationRelation',
              item.map((i) => Number(i.value)),
            )
          }}
          options={options}
          selectedOptions={(watchedRelations ?? []).map((selected: number) => ({
            label: `${t('page:simulation.input_order')}${selected}`,
            value: selected.toString(),
          }))}
        />
      </Term>
      <ColumnContent label={t('page:simulation.unit_price_buffer')}>
        <Text textStyle="textSm">{t('page:simulation.available')}</Text>
      </ColumnContent>
    </Stack>
  )
}
